import React from "react";
import { Card, Text } from 'grommet';

const SelectableCard = ({ subTitle, title, selected, onClick, paddingVertical = 5, paddingHorizontal = 20, textComponent }) => {
    const padding = {
        paddingTop: paddingVertical,
        paddingBottom: paddingVertical,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal
    }
    const style = selected ?
        { background: '#E92C70', color: '#fff', ...padding } :
        { background: '#F4F4F4', color: '#707070', ...padding };
    return (
        <Card justify='center' align='center'
            style={style} onClick={onClick}
        >
            {subTitle && subTitle.split('<br/>').map(s => <Text>{s}</Text>)}
            <Text><strong>{title}</strong></Text>
            {textComponent}
        </Card>
    )
}

export default SelectableCard;